import { createAction } from '@reduxjs/toolkit';

import type { AdvancedSecurityForm, AdvancedSecurityState } from './types';

export const generateCertificate = createAction(
    'sso/GENERATE_CERTIFICATE',
    (spCertificate: AdvancedSecurityState['spCertificate']) => ({ payload: { spCertificate } }),
);
export const submitForm = createAction('advancedSecurity/SUBMIT_FORM');
export const setSubmitting = createAction('advancedSecurity/SET_SUBMITTING', (submitting: boolean) => ({
    payload: submitting,
}));
export const setErrorMessage = createAction(
    'advancedSecurity/SET_ERROR_MESSAGE',
    (errorMessage: AdvancedSecurityState['errorMessage']) => ({ payload: errorMessage }),
);
export const setSpCertificate = createAction('advancedSecurity/SET_SP_CERTIFICATE', (spCertificate: string) => ({
    payload: spCertificate,
}));
export const updateFormData = createAction('advancedSecurity/UPDATE_FORM_DATA', (data: AdvancedSecurityForm) => ({
    payload: data,
}));
export const setInitialFormData = createAction(
    'advancedSecurity/SET_INITIAL_FORM_DATA',
    (data: AdvancedSecurityForm) => ({ payload: data }),
);
